import React from "react"
import propTypes from "prop-types"
import { Link } from "react-router-dom"

import { resetPassword } from "../../../../services/authentication"
import configs from "../../../../configs"

import Form, {
  Group,
  Input,
  Password,
  GeneralErrorMessage
} from "../../../../components/Form"
import Nav from "../../../../components/Nav"
import Logo from "../../../../components/Logo"
import Button from "../../../../components/Button"

class ResetPassword extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      user: {
        email: {
          label: "Email",
          name: "email",
          type: "email",
          value: "",
          required: true,
          class: ""
        },
        reset_password_key: {
          label: "Reset Password Key",
          name: "reset_password_key",
          type: "text",
          value: "",
          required: true,
          class: ""
        },
        password: {
          label: "Password",
          name: "password",
          type: "password",
          value: "",
          required: true,
          class: ""
        },
        confirm_password: {
          label: "Password Confirm",
          name: "confirm_password",
          type: "password",
          value: "",
          required: true,
          requiredField: "password",
          class: ""
        }
      },
      generalErrorMessage: "",
      isSubmitted: false,
      passwordIsUpdated: false,
      loading: false
    }
  }

  componentDidMount() {
    const {
      match: { params }
    } = this.props
    const { user } = this.state

    const newFields = {}

    if (params.email) {
      newFields.email = user.email
      newFields.email.value = params.email
    }

    if (params.code) {
      newFields.reset_password_key = user.reset_password_key
      newFields.reset_password_key.value = params.code
    }

    this.setState({
      user: {
        ...user,
        newFields
      }
    })
  }

  onChange = (name, field, value) => {
    const { user } = this.state

    this.setState({
      user: {
        ...user,
        [name]: {
          ...user[name],
          message: "",
          [field]: value
        }
      },
      generalErrorMessage: ""
    })
  }

  onSubmit = e => {
    e.preventDefault()

    const { user } = this.state

    this.setState({
      loading: true,
      generalErrorMessage: ""
    })

    resetPassword(user).then(
      () => {
        this.setState({
          loading: false,
          passwordIsUpdated: true
        })
      },
      fields => {
        this.setState({
          isSubmitted: true,
          loading: false,
          generalErrorMessage: fields.generalErrorMessage,
          user: {
            ...user,
            ...fields
          }
        })
      }
    )
  }

  render() {
    const {
      user,
      generalErrorMessage,
      isSubmitted,
      loading,
      passwordIsUpdated
    } = this.state

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-7 authentication_sidebar">
            <Logo color="white" href="/" title="Resanec" />
            <Logo color="black" href="/" title="Resanec" mobile />

            <div className="authentication_sidebar_container">
              <h1 className="authentication_sidebar_title">
                NDIS Pre-Planning
              </h1>
              <div className="authentication_sidebar_subtitle">
                Online is easy. When done together, it’s better.
              </div>
              <div className="authentication_sidebar_description">
                <ul>
                  <li>Easy collaboration with family, friends</li>
                  <li>Efficient editing and revising capability</li>
                  <li>
                    Dynamic commenting facility to provide input and feedback on
                    pre-plan progress and is
                  </li>
                  <li>ideal if you live in a remote location....and more.</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-5 authentication_content authentication_content--dark">
            <Nav
              navigation={configs.authentication.navigation}
              className="nav--right nav--dark"
            />

            <div className="authentication_content_container">
              <h2 className="authentication_content_title">Reset Password</h2>

              {passwordIsUpdated ? (
                <div className="authentication_content_description">
                  Your password has been reset. You can now{" "}
                  <Link to="/sign-in">Sign In to your account</Link>
                </div>
              ) : (
                <Form onSubmit={this.onSubmit}>
                  <Group>
                    <Input
                      onChange={this.onChange}
                      isSubmitted={isSubmitted}
                      field={user.email}
                    />
                  </Group>

                  <Group className="form_group--hidden">
                    <Input
                      onChange={this.onChange}
                      isSubmitted={isSubmitted}
                      field={user.reset_password_key}
                    />
                  </Group>

                  <Group>
                    <Password
                      onChange={this.onChange}
                      isSubmitted={isSubmitted}
                      field={user.password}
                    />
                  </Group>

                  <Group>
                    <Password
                      onChange={this.onChange}
                      isSubmitted={isSubmitted}
                      field={user.confirm_password}
                    />
                  </Group>

                  {generalErrorMessage && (
                    <GeneralErrorMessage message={generalErrorMessage} />
                  )}

                  <Group className="form_group--padding-top-lg">
                    <Button
                      button={{ type: "submit", disabled: loading }}
                      className="btn--secondary btn--width-full btn--height-md"
                    >
                      Send
                    </Button>
                  </Group>
                </Form>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ResetPassword.propTypes = {
  match: propTypes.shape({
    params: propTypes.shape({
      email: propTypes.string,
      code: propTypes.oneOfType([propTypes.number, propTypes.string])
    })
  }).isRequired,
  history: propTypes.shape({
    push: propTypes.func
  }).isRequired
}

ResetPassword.preventDefault = {
  match: {
    params: {
      email: "",
      code: ""
    }
  }
}

export default ResetPassword
